// fetchers for routines
import { createThunkRoutine } from "redux-thunk-routine";

export const FetchDataRoutine = createThunkRoutine("radiologyReports/FETCH_DATA");
export const GenerateDataRoutine = createThunkRoutine("radiologyReports/ORDER_REPORT");
export const SET_FILTERS = "radiologyReports/SET_FILTERS";
